import { ClientContactConversation } from "@jugl-web/rest-api/contacts";

export const mergeContactConversations = (
  existingConversations: ClientContactConversation[],
  conversation: ClientContactConversation
): ClientContactConversation[] => {
  const withoutDuplicate = existingConversations.filter(
    (item) => item.conv_id !== conversation.conv_id
  );

  return [...withoutDuplicate, conversation];
};
